import { UserRole, DeviceStatus } from '@/types/api';
import type { DeviceType, AlertType } from '@/types/api';

export const roleLabel: Record<UserRole, string> = {
  [UserRole.Owner]: 'Sys Admin',
  [UserRole.Admin]: 'Admin',
  [UserRole.Manager]: 'Manager',
  [UserRole.Viewer]: 'Viewer',
};

export const deviceTypeLabel: Record<DeviceType, string> = {
  WaterMeter: 'Water Meter',
  SALTTransmitter: 'SALT Transmitter',
};

export const readingLabelByDeviceType: Record<DeviceType, string> = {
  WaterMeter: 'Total Usage (gal.)',
  SALTTransmitter: 'Pulse Count',
};

export const deviceStatusLabel: Record<DeviceStatus, string> = {
  Provisioned: 'Registered',
  Active: 'Active',
  Inactive: 'Inactive',
  Error: 'Error',
};

// "Provisioned" means the device is registered in our system. It does
// not mean the device has joined the LoRaWAN network or transmitted —
// that comes minutes-to-days later. Showing "Registered" hides that
// gap. Surface "Not joined" while the device is provisioned but has
// never joined so an installer can tell paperwork apart from a live
// meter at a glance.
export function deviceStatusDisplay(
  status: DeviceStatus,
  joinedAt: string | null | undefined,
): string {
  if (status === DeviceStatus.Provisioned && !joinedAt) return 'Not joined';
  return deviceStatusLabel[status] ?? status;
}

export const alertTypeLabel: Record<AlertType, string> = {
  PipeEmpty: 'Pipe Empty',
  NoUsage30Days: 'No Usage in 30 Days',
  MinTemperatureExceeded: 'Low Temperature',
  MaxTemperatureExceeded: 'High Temperature',
  LowSignal: 'Low Signal',
  BurstPipeDetected: 'Burst Pipe',
  LeakDetected: 'Suspected Leak',
  ReverseFlowDetected: 'Reverse Flow',
  LowBattery: 'Low Battery',
  LowTemperature: 'Low Temperature (SALT)',
  SensusReadError: 'Sensus Read Error',
  CoverRemoved: 'Cover Removed',
};
